import styled from "styled-components";

export const EditStructureWrapper = styled.div`
  width: 100%;
  margin-top: 40px;
  margin-bottom: 10px;
  height: 500px;
`;

export const EditStructureHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13.48px;

  > .title {
    color: #1a191a;
    font-family: Pretendard;
    font-size: 20.22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const EditStructureHeaderButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  > .button {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 8px 12px;
    cursor: pointer;
    color: #444;
    background-color: #f0f0f0;
    border-radius: 14px;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 600;
    line-height: 120%;

    > img {
      width: 16px;
    }
  }

  > .button.purple {
    background: #7f25fb;
    color: #fff;
  }
`;

export const EditStructureTableWrapper = styled.div`
  padding: 0 20px;
  box-sizing: border-box;
  flex: 1;
  background-color: #f0f0f0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

export const EditStructureTableHeader = styled.div`
  width: 946px;
  padding: 20px 0px 14px;
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid #d9d9d9;
  position: relative;
  background-color: #f0f0f0;

  > .box {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #121212;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  > .box.z {
    width: 6%;
  }

  > .box.a {
    width: 50px;
  }

  > .box.c {
    width: 11%;
  }

  > .box.d {
    width: 14%;
  }
`;

export const EditStructureMoveButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 16px;

  > img {
    cursor: pointer;
  }
`;

export const EditStructureTableBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  overflow-y: auto;
  scrollbar-width: none;
  max-height: 375px;
  padding: 15px 0;
  box-sizing: border-box;
`;

export const EditStructureTableItemWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 40px;
  align-items: center;
  gap: 7px;
`;

export const EditStructureTableItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 40px;
  border-radius: 15.04px;
  background: #fff;
  padding: 0 17px;

  > .box {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > .box.a {
    width: 50px;
    font-weight: 500;
  }
`;

export const EditStructureItemCheckBox = styled.div<{ checked: boolean }>`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  background: ${(p) => (p.checked ? "#7f25fb" : "#fff")};
`;

export const EditStructureItemBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--kakao-logo, #000);
  text-align: center;
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const EditStructureTimeItem = styled(EditStructureItemBox)`
  width: 13%;
  > .data {
    width: 50px;
    height: 24px;
    border-radius: 10px;
    background: #f0f0f0;
    text-align: center;
    border: none;
    outline: none;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const EditStructureBreakItem = styled(EditStructureItemBox)`
  width: 45%;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    width: calc(100% - 32px);
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 10px;
    background: #f0f0f0;
  }
`;

export const EditStructureItem = styled(EditStructureItemBox)`
  width: 15%;
  > .data {
    width: 90px;
    height: 24px;
    border-radius: 10px;
    background: #f0f0f0;
    text-align: center;
    border: none;
    outline: none;
    color: var(--kakao-logo, #000);
    text-align: center;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const EditStructureButton = styled.div<{ $isLevel: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 41px;
  cursor: pointer;
  border-radius: 14px;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  background: ${(p) => (p.$isLevel ? "#f0f0f0" : "#7f25fb")};
  color: ${(p) => (p.$isLevel ? "#444" : "#fff")};
`;

export const EditStructureItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
